import { render, staticRenderFns } from "./SlideSearchPopup.vue?vue&type=template&id=4a8bf5d4&scoped=true&"
import script from "./SlideSearchPopup.vue?vue&type=script&lang=js&"
export * from "./SlideSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearchPopup.vue?vue&type=style&index=0&id=4a8bf5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bf5d4",
  null
  
)

export default component.exports